import React from "react"

import { useApiContext } from "~/api"
import { AddingEventCard } from "~/components/ContentEditable/components/AddingEventCard/AddingEventCard"
import { ContentEditable } from "~/components/ContentEditable/ContentEditable"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const Content: React.FC = () => {
  const content = useApiContext("/calendar/element")

  return (
    <div className={styles.Wrapper}>
      <div className={styles.ColLeft}>
        <Heading className={styles.Heading} like="h1">
          <Raw html={content.name} />
        </Heading>

        <AddingEventCard className="d-sm-none" />
        <ContentEditable>
          <Raw html={content.text} />
        </ContentEditable>
      </div>

      <div className={styles.ColRight}>
        <AddingEventCard />
      </div>
    </div>
  )
}
